// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ae502fc7","239":"1c5e1446","455":"b244c0cd"}[chunkId] + ".chunk.js";
};